// OAuth terminal pages do not initialize workspace entitlements and render
// without the protected app shell (AD-10 / AIS-2229). Keep this list in one
// place so shell and access-gate decisions cannot drift.
export const BARE_ROUTE_SEGMENTS = ["/error", "/callback-success"] as const;

/** Normalize a pathname to the exact route below its locale segment. */
export function getLocaleRelativePath(
  pathname: string | null | undefined,
  locale: string,
): string {
  const normalizedPathname = pathname || "/";
  const localePrefix = `/${locale}`;
  const localeRelativePath =
    normalizedPathname === localePrefix
      ? "/"
      : normalizedPathname.startsWith(`${localePrefix}/`)
        ? normalizedPathname.slice(localePrefix.length)
        : normalizedPathname;

  if (localeRelativePath === "/") {
    return localeRelativePath;
  }

  return localeRelativePath.endsWith("/")
    ? localeRelativePath.slice(0, -1)
    : localeRelativePath;
}

/** Returns true when the given locale-stripped path is a bare route. */
export function isBareRoute(localeRelativePath: string): boolean {
  return (BARE_ROUTE_SEGMENTS as readonly string[]).includes(
    localeRelativePath,
  );
}
